import { BiChevronLeft } from "react-icons/bi";
import {
  MdOutlineSmartToy,
  MdOutlineAddBox,
  MdOutlineContentCopy,
  MdOutlineToggleOn,
} from "react-icons/md";
import bot1 from "../../asset/Images/faq/bot/configuration/1.png";
import bot2 from "../../asset/Images/faq/bot/configuration/2.png";
import bot3 from "../../asset/Images/faq/bot/configuration/3.png";
import React from "react";
import { useNavigate } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import styles from "../../styles/Components/faq/BotConfigurationHelp.module.css";

function BotConfigurationHelp() {
  const navigate = useNavigate();

  return (
    <div className={styles.helpWrapper}>
      <div className={styles.backBtn} onClick={() => navigate("/faq/all")}>
        <BiChevronLeft />
        <span>Back to Help Center</span>
      </div>

      <div className={`${styles.heroCard} ${styles.heroBot}`}>
        <div className={`${styles.heroIcon} ${styles.heroIconBot}`}>
          <MdOutlineSmartToy />
        </div>
        <div className={styles.heroContent}>
          <h3 className={styles.heroTitle}>Create Bot</h3>
          <p className={styles.heroDesc}>
            The AI Bot page lets you manage your trading bots.
          </p>
        </div>
      </div>

      <div className={styles.stepContainer}>
        <div className={styles.stepHeader}>
          <div className={`${styles.stepNumWrap} ${styles.stepNumBot}`}>
            <span className={styles.stepNum}>1</span>
          </div>
          <div className={styles.stepInfo}>
            <h4 className={styles.stepTitle}>Start a New Bot</h4>
            <div className={styles.stepTag}>
              <MdOutlineAddBox />
              Initiate
            </div>
          </div>
        </div>
        <div className={styles.subStepWrapper}>
          <div className={styles.subStepContainer}>
            <ul className={styles.helpList}>
              <li>To create a bot, click on the "Start New Bot" button.</li>
            </ul>
            <div className={styles.imageWrap}>
              <LazyLoadImage
                src={bot2}
                alt="create bot"
                effect="blur"
                wrapperClassName="imageContainer"
              />
            </div>
          </div>
        </div>
      </div>

      <div className={styles.stepContainer}>
        <div className={styles.stepHeader}>
          <div className={`${styles.stepNumWrap} ${styles.stepNumBot}`}>
            <span className={styles.stepNum}>2</span>
          </div>
          <div className={styles.stepInfo}>
            <h4 className={styles.stepTitle}>Choose a Creation Method</h4>
            <div className={`${styles.stepTag} ${styles.tagBuild}`}>
              <MdOutlineContentCopy />
              Build or Copy
            </div>
          </div>
        </div>
        <div className={styles.subStepWrapper}>
          <div className={styles.subStepContainer}>
            <ul className={styles.helpList}>
              <li>
                You can either build a new bot manually by selecting Create Bot
                Manually or copy an existing bot from the table by clicking
                "Copy Bot".
              </li>
            </ul>
            <div className={styles.imageWrap}>
              <LazyLoadImage
                src={bot3}
                alt="create bot"
                effect="blur"
                wrapperClassName="imageContainer"
              />
            </div>
          </div>
        </div>
      </div>

      <div className={styles.stepContainer}>
        <div className={styles.stepHeader}>
          <div className={`${styles.stepNumWrap} ${styles.stepNumBot}`}>
            <span className={styles.stepNum}>3</span>
          </div>
          <div className={styles.stepInfo}>
            <h4 className={styles.stepTitle}>Activate Your Bot</h4>
            <div className={`${styles.stepTag} ${styles.tagActivate}`}>
              <MdOutlineToggleOn />
              Enable Trading
            </div>
          </div>
        </div>
        <div className={styles.subStepWrapper}>
          <div className={styles.subStepContainer}>
            <ul className={styles.helpList}>
              <li>
                Once your bot is set up, you can click on the "Activate" button
                to enable it for trading.
              </li>
            </ul>
            <div className={styles.imageWrap}>
              <LazyLoadImage
                src={bot1}
                alt="ai assistant"
                effect="blur"
                wrapperClassName="imageContainer"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BotConfigurationHelp;
